import { Container, Row, Col } from 'react-bootstrap';
//import CourseSidebar from '../../ui/CourseSidebar';
import CourseItemGrid from '../CourseItemGrid';
import { Styles } from './styles';
import BreadcrumbComponent from '../../ui/Breadcrumb';
import { Courses } from '../../../types/schema';
import { imageConstraints } from '../../../utils/constraints';

export type CourseGridPageTemplateProps = {
  courses: Courses[];
  metaTitle?: string;
  metaDescription?: string;
};

const CourseGridPageTemplate: React.FC<CourseGridPageTemplateProps> = ({ courses }) => {
  return (
    <div className="main-wrapper course-page">
      {/* Breadcroumb */}
      <BreadcrumbComponent title="Cursos" image={imageConstraints['Course-Grid-Hero']} />
      <Styles>
        {/* Course Grid */}
        <section className="course-grid-area">
          <Container>
            <Row>
              {/* <Col lg="12" md="4" sm="5">
                <CourseSidebar />
              </Col> */}
              <Col lg="12" md="12" sm="12">
                <div className="course-items">
                  <Row>
                    <CourseItemGrid data={courses} />
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Styles>
    </div>
  );
};

export default CourseGridPageTemplate;
